/**
 * Inline CTA — sits between results and the Foundations banner. Soft pitch:
 * "Want to learn how to interpret these measurements?" + course button.
 *
 * One of the three Foundations touch points (locked at 3 — nav button, this,
 * banner). Pure render.
 */

import { el } from "../dom";
import { MARKETING } from "../marketing";

import "./inline-cta.css";

export interface InlineCtaHandle {
  el: HTMLElement;
}

export function createInlineCta(): InlineCtaHandle {
  const root = el(
    "section",
    { class: "inline-cta no-print" },
    el(
      "div",
      { class: "container inline-cta__inner" },
      el("p", { class: "inline-cta__headline" }, MARKETING.inlineCTA.headline),
      el(
        "a",
        {
          href: MARKETING.inlineCTA.url,
          class: "inline-cta__button",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        MARKETING.inlineCTA.label,
      ),
    ),
  );

  return { el: root };
}
